import React from 'react'
import { ThemeProvider } from 'styled-components'
import PropTypes from 'prop-types'
import theme from './theme'
import 'whatwg-fetch'

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
export const wrapRootElement = ({ element }) => <ThemeProvider theme={theme}>{element}</ThemeProvider>

wrapRootElement.propTypes = {
  element: PropTypes.element.isRequired,
}
